<template>
    <div class="welcome">
        <div class="welcome-bg"></div>
        <div class="welcome-dots"></div>
        <div class="welcome-lines"></div>

        <div class="welcome-content">
            <div class="welcome-badge">
                <span class="welcome-glow"></span>
                <span class="welcome-check">
                    <v-icon size="46" color="#0A0E14">mdi-check</v-icon>
                </span>
            </div>

            <div class="welcome-title">{{ $t('entrance.welcome_title') }}</div>
            <div class="welcome-subtitle">{{ subtextMessage }}</div>

            <v-btn
                v-if="!showRetryBtn"
                color="primary" depressed large block
                class="black--text text-none font-weight-bold welcome-btn"
                @click="continueToHome" :loading="loading">
                {{ $t('common.continue') }}
            </v-btn>
            <v-btn
                v-else
                color="primary" depressed large block
                class="black--text text-none font-weight-bold welcome-btn"
                @click="onRetry" :loading="loading">
                {{ $t('common.retry') }}
            </v-btn>
        </div>
    </div>
</template>

<script>

import scrollLock from '@/mixins/scrollLock'

export default {
    mixins: [scrollLock],
    props: {
        loading: {
            type: Boolean,
            default: false,
        },
        showRetryBtn: {
            type: Boolean,
            default: false,
        }
    },
    computed: {
        subtextMessage(vm = this) {
            switch (vm.account?.accountType) {
                case 'coach':
                    return vm.$t('entrance.welcome_subtitle_coach')
                case 'student':
                    return vm.$t('entrance.welcome_subtitle')
                case 'company':
                    return vm.$t('company.welcome_subtitle')
                default:
                    return ''
            }
        }
    },
    methods: {
        continueToHome() {
            const vm = this
            vm.$emit('continue')
        },
        onRetry() {
            const vm = this
            vm.$emit('retry')
        },
    },
}
</script>

<style scoped>

.welcome {
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06080C;
    padding: 40px 24px;
    overflow-x: hidden;
    overflow-y: auto;
}

.welcome-bg {
    position: absolute;
    inset: 0;
    background:
        radial-gradient(ellipse 70% 60% at 30% 40%, rgba(204, 255, 51, 0.12) 0%, transparent 70%),
        radial-gradient(ellipse 60% 70% at 75% 70%, rgba(51, 153, 153, 0.14) 0%, transparent 65%),
        radial-gradient(ellipse 40% 40% at 60% 20%, rgba(102, 204, 204, 0.08) 0%, transparent 60%),
        #06080C;
}

.welcome-dots {
    position: absolute;
    inset: 0;
    background-image: radial-gradient(circle, rgba(255, 255, 255, 0.06) 1.5px, transparent 1.5px);
    background-size: 32px 32px;
    background-repeat: repeat;
}

.welcome-lines {
    position: absolute;
    inset: 0;
    overflow: hidden;
}

.welcome-lines::before {
    content: '';
    position: absolute;
    top: -80px;
    left: -80px;
    width: 420px;
    height: 420px;
    border-radius: 50%;
    border: 1px solid rgba(204, 255, 51, 0.08);
}

.welcome-lines::after {
    content: '';
    position: absolute;
    bottom: -100px;
    right: -60px;
    width: 500px;
    height: 500px;
    border-radius: 50%;
    border: 1px solid rgba(51, 153, 153, 0.1);
}

.welcome-content {
    position: relative;
    z-index: 1;
    width: 100%;
    max-width: 360px;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    animation: welcome-fade-up .5s ease both;
}

.welcome-badge {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 30px;
    animation: welcome-badge-pop .6s cubic-bezier(.34, 1.56, .64, 1) both;
    animation-delay: .12s;
}

@keyframes welcome-fade-up {
    from { opacity: 0; transform: translateY(14px); }
    to { opacity: 1; transform: none; }
}

@keyframes welcome-badge-pop {
    0% { opacity: 0; transform: scale(.7); }
    60% { transform: scale(1.06); }
    100% { opacity: 1; transform: scale(1); }
}

.welcome-glow {
    position: absolute;
    width: 280px;
    height: 280px;
    border-radius: 50%;
    background: radial-gradient(circle, rgba(204, 255, 51, 0.28) 0%, rgba(51, 153, 153, 0.16) 45%, transparent 70%);
    filter: blur(8px);
}

.welcome-check {
    position: relative;
    width: 92px;
    height: 92px;
    border-radius: 50%;
    background: var(--brand-gradient);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 12px 36px rgba(204, 255, 51, 0.22);
}

.welcome-title {
    font-size: 32px;
    font-weight: 800;
    letter-spacing: -0.02em;
    line-height: 1.15;
    color: #F2F5FA;
}

.welcome-subtitle {
    font-size: 16px;
    line-height: 1.5;
    color: rgba(242, 245, 250, 0.6);
    margin-top: 12px;
}

.welcome-btn {
    margin-top: 36px;
}

</style>
